import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { GStatic } from '../../../services/GStatic';
import { GAnalyticsService } from '../../../services/g-analytics.service';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
  selector: 'app-toolbar-btn',
  templateUrl: './toolbar-btn.component.html',
  styleUrls: ['./toolbar-btn.component.scss'],
})
export class ToolbarBtnComponent implements OnInit {
  @Output() myClick = new EventEmitter();

  @Input() icon: string = 'heroicons_outline:newspaper';
  @Input() onOff: boolean = false;
  @Input() hint: string = '';
  @Input() hintPosition: TooltipPosition = 'left';

  // settings
  @Input() disabled: boolean = false;
  @Input() measurmentButton: boolean = false;
  @Input() measurmentStatus: string;
  @Input() switch: boolean = false;
  @Input() innerIcon: boolean = false;
  @Input() innerIconOn: string = 'heroicons_outline:eye';
  @Input() innerIconOff: string = 'heroicons_outline:eye-off';
  @Input() iconClass: string = '';
  @Input() innerIconClass: string = '';

  isMobile = GStatic.isMobile();

  constructor(public googleServices: GAnalyticsService) {}

  ngOnInit(): void {}

  onClick($event): void {
    if (!this.disabled) {
      this.myClick.emit($event);
    }
  }

  getMeasurementStatus() {
    if (this.measurmentStatus === 'notReady') return 'notReady';
    else if (this.measurmentStatus === 'processing') return 'processing';
    else return 'ready';
  }
}
